import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { setShouldUpdateId } from 'store/player/actions.ts';
import { StreamTypes } from 'store/player/actions.types.ts';
import { RBChannel } from 'store/railsBuilder/reducer.types.ts';

import parseVideoItem from 'services/data-manager/parsing/parseVideoItem.ts';
import { VideoItem } from 'services/data-manager/types.ts';

import useGetLiveProgram from 'utils/hooks/useGetLiveProgram.ts';
import usePrevious from 'utils/hooks/usePrevious.ts';

import { SwitchPlayerSource } from 'screens/PlayerModal/types.ts';

type Params = {
    isLive: boolean;
    channel: RBChannel | undefined;
    videoItem: VideoItem | undefined;
    playerProgress: number;
    onSwitchPlayerSource: SwitchPlayerSource;
    onSetVideoDuration(duration: number): void;
};

function useLiveProgramFinished({
    isLive,
    channel,
    videoItem,
    playerProgress,
    onSwitchPlayerSource,
    onSetVideoDuration,
}: Params) {
    const dispatch = useDispatch();
    const onGetLiveProgram = useGetLiveProgram();

    const previousVideoItem = usePrevious(videoItem);

    // Handle live program finished
    useEffect(() => {
        (async () => {
            let duration = videoItem?.duration;

            if (!duration && videoItem?.endTime && videoItem.startTime) {
                duration = videoItem.endTime - videoItem.startTime;
            }

            if (
                isLive &&
                videoItem &&
                videoItem.channelId &&
                videoItem === previousVideoItem &&
                duration &&
                playerProgress >= duration
            ) {
                const nextProgram = await onGetLiveProgram(videoItem.channelId);
                const nextVideoItem = parseVideoItem({
                    channel: channel!,
                    program: nextProgram,
                });

                dispatch(setShouldUpdateId(false));

                onSwitchPlayerSource(nextVideoItem, StreamTypes.live);

                if (nextVideoItem?.duration != null) {
                    onSetVideoDuration(nextVideoItem.duration);
                } else if (nextVideoItem?.startTime && nextVideoItem?.endTime) {
                    onSetVideoDuration(
                        nextVideoItem.endTime - nextVideoItem.startTime,
                    );
                }
            }
        })();
    }, [playerProgress]);
}

export default useLiveProgramFinished;
